import { styled } from "styled-components";

export const ProfileEditPageBtn = styled.button`
  font-size: 24px;
  color: white;

  background-color: #383838;
  border: 0;
  border-radius: 30px;
  width: 284px;

  &:hover {
    background-color: #808080;
  }
`;
